import { reportApi } from "../../../../../apis/reportApi";

export function searchReport(
  trackingSysId,
  pageNum,
  quantityItemsPerPage,
  setItems,
  setTotalPages,
  setHousesPresent,
  setMessageError
) {
  reportApi
    .getHousePending(trackingSysId, pageNum, quantityItemsPerPage)
    .then((items) => {
      if (items.data.houses.length !== 0) {
        setItems(items.data.houses);
        setTotalPages(items.data.totalPages);
        setHousesPresent(true);
      } else {
        setHousesPresent(false);
      }
    })
    .catch((error) => {
      console.error("Ocorreu um erro ao buscar houses pendentes.", error);
      setHousesPresent(null);
      setMessageError(error.message);
    });
}
